<div class="eom">
  <!-- Header verde, fijo. Pestañas (03/11/2026): con los márgenes el modal ya no
       cabía en la pantalla; cada pestaña muestra solo lo suyo y el cuerpo
       scrollea entre esta cabecera y el pie. -->
  <div class="eom-cabecera" style="background: linear-gradient(135deg, #f0fdf4, #ecfdf5); padding: 20px 24px 14px; border-bottom: 2px solid #bbf7d0;">
    <div style="display: flex; align-items: center; gap: 10px;">
      <mat-icon style="color: #1C593D; font-size: 28px; width: 28px; height: 28px;">tune</mat-icon>
      <h1 style="font-size: 1.25rem; font-weight: 700; color: #1e5a3f; margin: 0;">Actualizar Parámetros</h1>
    </div>
    <div class="eom-pestanas" role="tablist" aria-label="Secciones de Actualizar Parámetros" (keydown)="teclaPestanas($event)">
      <button *ngFor="let p of pestanas" type="button" role="tab" class="eom-pestana"
        [id]="'eom-tab-' + p.valor" [attr.aria-controls]="'eom-panel-' + p.valor"
        [attr.aria-selected]="pestana === p.valor" [attr.tabindex]="pestana === p.valor ? 0 : -1"
        [class.is-activa]="pestana === p.valor" (click)="elegirPestana(p.valor)">
        {{ p.etiqueta }}
        <ng-container *ngIf="p.valor === 'margenes'">
          <span *ngIf="motorGuardado as m" class="eom-pestana-chip">Motor: {{ m === 'MARGENES' ? 'Márgenes' : 'Legado' }}</span>
          <span *ngIf="margenesPendientes" class="eom-pestana-punto" aria-hidden="true"></span>
          <span *ngIf="margenesPendientes" class="sr-only">(cambios sin guardar)</span>
        </ng-container>
      </button>
    </div>
  </div>

  <div class="eom-cuerpo">
    <!-- Pestaña «Parámetros del operador». [hidden] y no *ngIf: lo escrito en una
         pestaña sigue ahí al volver de la otra. -->
    <form *ngIf="form" [formGroup]="form" id="eom-panel-parametros" role="tabpanel"
      aria-labelledby="eom-tab-parametros" [hidden]="pestana !== 'parametros'">
      <!-- Selector de operador -->
      <div class="mb-4">
        <mat-form-field appearance="outline" class="w-full modern-field">
          <mat-label>Operador</mat-label>
          <mat-icon matPrefix style="color: #1C593D; margin-right: 8px;">business</mat-icon>
          <mat-select formControlName="operador">
            <mat-option *ngFor="let op of operadores" [value]="op.value">
              {{ op.label }}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="form.get('operador')?.invalid">
            {{ getErrorMessage('operador') }}
          </mat-error>
        </mat-form-field>
      </div>

      <!-- Motor Márgenes vigente: estos campos siguen guardándose, pero no mueven CLP ↔ VES -->
      <div *ngIf="motorMargenesActivo" class="eom-nota-motor mb-4" role="note">
        <mat-icon aria-hidden="true">info</mat-icon>
        <span>{{ textoLegadoNoAfecta }}</span>
      </div>

      <!-- Grid de campos -->
      <div class="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4">
        <mat-form-field appearance="outline" class="modern-field">
          <mat-label>Descuento Fiat</mat-label>
          <mat-icon matPrefix style="color: #1C593D; margin-right: 8px;">discount</mat-icon>
          <input matInput type="number" formControlName="descuentoFiat" step="0.0001"/>
          <mat-error *ngIf="form.get('descuentoFiat')?.invalid">
            {{ getErrorMessage('descuentoFiat') }}
          </mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" class="modern-field">
          <mat-label>Comisión CLP - VES (%)</mat-label>
          <mat-icon matPrefix style="color: #1C593D; margin-right: 8px;">percent</mat-icon>
          <input matInput type="number" formControlName="comision" step="0.1"/>
          <mat-error *ngIf="form.get('comision')?.invalid">
            {{ getErrorMessage('comision') }}
          </mat-error>
        </mat-form-field>
      </div>

      <div class="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4">
        <mat-form-field appearance="outline" class="modern-field">
          <mat-label>Rate VES/USDT</mat-label>
          <mat-icon matPrefix style="color: #1C593D; margin-right: 8px;">swap_vert</mat-icon>
          <input matInput type="number" formControlName="rateVesUsdt" step="0.01"/>
          <mat-hint *ngIf="!isRateEditable" style="font-size: 0.7rem;">
            Automático para {{ form.get('operador')?.value }}
          </mat-hint>
          <mat-error *ngIf="form.get('rateVesUsdt')?.invalid">
            {{ getErrorMessage('rateVesUsdt') }}
          </mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" class="modern-field">
          <mat-label>USD/CLP</mat-label>
          <mat-icon matPrefix style="color: #1C593D; margin-right: 8px;">attach_money</mat-icon>
          <input matInput type="number" formControlName="usdClp" step="0.01"/>
          <mat-error *ngIf="form.get('usdClp')?.invalid">
            {{ getErrorMessage('usdClp') }}
          </mat-error>
        </mat-form-field>
      </div>

      <!-- Separador VES->CLP -->
      <hr style="border: none; border-top: 1px solid #d1d5db; margin: 12px 0 16px;">

      <div class="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4">
        <mat-form-field appearance="outline" class="modern-field">
          <mat-label>Comisión VES - CLP (%)</mat-label>
          <mat-icon matPrefix style="color: #1C593D; margin-right: 8px;">percent</mat-icon>
          <input matInput type="number" formControlName="comisionVesClp" step="0.1"/>
          <mat-error *ngIf="form.get('comisionVesClp')?.invalid">
            {{ getErrorMessage('comisionVesClp') }}
          </mat-error>
        </mat-form-field>
      </div>

      <!-- Ganancia real VES->CLP (informativa): píldora, regla −1 % a +2 % y una sola recomendación.
           Describe la fórmula de siempre: con el motor Márgenes no aplica y no se pinta. -->
      <div *ngIf="!motorMargenesActivo && gananciaVesClp as g" class="mb-4 ganancia" [ngClass]="'ganancia--' + g.nivel">
        <div class="ganancia-titulo">Ganancia real VES → CLP</div>
        <div class="ganancia-pildora" aria-live="polite">
          <span class="ganancia-cifra">{{ pct(g.gananciaPct) }}</span>
          <span class="ganancia-nivel">· {{ etiquetaNivel(g) }}</span>
        </div>

        <div class="regla" role="img" [attr.aria-label]="'Ganancia ' + pct(g.gananciaPct) + ' en una regla de −1 % a +2 %'">
          <div class="regla-barra"></div>
          <div class="regla-marcador" [style.left.%]="posicion(g)"></div>
          <span *ngFor="let m of marcasRegla" class="regla-marca" [style.left.%]="m.pos">{{ m.texto }}</span>
        </div>

        <div *ngIf="g.gananciaPct < gananciaSugeridaPct" class="ganancia-reco">
          Para ganar {{ gananciaSugeridaPct }} % sube «Comisión VES - CLP» a ≈
          <b>{{ numero(g.comisionParaSugerida) }}</b>.
        </div>

        <details class="ganancia-detalle">
          <summary>¿Cómo se calcula?</summary>
          <p>
            La comisión VES - CLP se suma a una tasa que ya descontó la comisión CLP - VES,
            por eso la ganancia es aprox. <b>VES-CLP − CLP-VES</b>. Se mide en la franja más grande;
            las menores suman sus descuentos encima.
          </p>
        </details>
      </div>
    </form>

    <!-- ══════════ Márgenes CLP ↔ VES (motor de márgenes, 03/11/2026) ══════════ -->
    <!-- Se guardan aparte de los parámetros: botón propio y un paso de confirmación
         antes del PUT. Editar, solo con el permiso de tasas; si no, solo lectura. -->
    <!-- Pestaña «Márgenes CLP ↔ VES» -->
    <section class="mv" id="eom-panel-margenes" role="tabpanel" aria-labelledby="eom-tab-margenes"
      [hidden]="pestana !== 'margenes'"
      [attr.aria-busy]="pasoMargenes === 'cargando' || guardandoMargenes">
      <div class="mv-cabecera">
        <h2 id="mv-titulo" class="mv-titulo">
          <mat-icon aria-hidden="true">percent</mat-icon>
          Márgenes CLP ↔ VES
        </h2>
        <span *ngIf="motorGuardado as m" class="mv-motor" [class.mv-motor--margenes]="m === 'MARGENES'">
          Motor: {{ m === 'MARGENES' ? 'Márgenes' : 'Legado' }}
        </span>
        <span *ngIf="margenesSoloLectura" class="mv-solo-lectura">
          <mat-icon aria-hidden="true">lock</mat-icon>Solo lectura
        </span>
      </div>

      <div *ngIf="pasoMargenes === 'cargando'" class="mv-cargando" role="status">
        <mat-spinner diameter="20"></mat-spinner>
        <span>Cargando márgenes…</span>
      </div>

      <div *ngIf="pasoMargenes === 'error'" class="mv-aviso mv-aviso--rojo" role="alert">
        <span>{{ errorCargaMargenes }}</span>
        <button type="button" class="mv-btn mv-btn--secundario" (click)="cargarMargenes()">Reintentar</button>
      </div>

      <ng-container *ngIf="margenesVes && borradorMargenes && pasoMargenes !== 'cargando' && pasoMargenes !== 'error'">
        <!-- Spot cruzado de la última lectura (USD/CLP y VES/USDT guardados del operador activo) y su hora -->
        <p *ngIf="margenesVes.spotCruzado as spot; else sinSpot" class="mv-spot">
          <span>Spot cruzado <b>{{ formatoTasa(spot.vesClp) }}</b> VES por 1 CLP</span>
          <span class="mv-sep" aria-hidden="true">·</span>
          <span><b>{{ formatoTasa(spot.clpVes) }}</b> CLP por 1 VES</span>
          <span *ngIf="margenesVes.operador" class="mv-spot-origen">(VES/USDT de {{ margenesVes.operador }})</span>
          <span *ngIf="horaLectura as hora" class="mv-spot-origen">· leído a las {{ hora }}</span>
        </p>
        <ng-template #sinSpot>
          <p class="mv-aviso mv-aviso--ambar">{{ textoSinSpot }}</p>
        </ng-template>

        <!-- Otro operador cambió lo guardado mientras se editaba: el borrador ya se rebasó -->
        <p *ngIf="avisoMargenes && (editandoMargenes || enConfirmacion)" class="mv-aviso mv-aviso--ambar" role="alert">
          <mat-icon aria-hidden="true">group</mat-icon>
          <span>{{ avisoMargenes }}</span>
        </p>

        <!-- ───── Viendo / editando: motor y tabla 2×2 ───── -->
        <ng-container *ngIf="!enConfirmacion">
          <!-- Radios nativos: Tab entra al grupo y las flechas cambian de motor -->
          <fieldset class="mv-campo mv-motores-grupo" [disabled]="!editandoMargenes">
            <legend class="mv-etiqueta">Motor de las tasas CLP ↔ VES</legend>
            <div class="mv-motores">
              <label *ngFor="let m of motores" class="mv-opcion" [class.is-activa]="borradorMargenes.motor === m.valor">
                <input type="radio" class="mv-radio" name="mv-motor" [value]="m.valor"
                  [checked]="borradorMargenes.motor === m.valor"
                  [disabled]="!editandoMargenes"
                  (change)="elegirMotor(m.valor)" />
                <span>{{ m.etiqueta }}</span>
              </label>
            </div>
          </fieldset>

          <div class="mv-tabla-caja">
            <table class="mv-tabla">
              <thead>
                <tr>
                  <th scope="col">Ruta</th>
                  <th scope="col" class="is-num">Margen mínimo <span class="mv-th-nota">TECHO · mejor para el cliente</span></th>
                  <th scope="col" class="is-num">Margen máximo <span class="mv-th-nota">PISO · peor para el cliente</span></th>
                </tr>
              </thead>
              <tbody>
                <ng-container *ngFor="let r of rutas; trackBy: trackRuta">
                  <tr>
                    <th scope="row">{{ r.etiqueta }} <span class="mv-th-nota">{{ r.entrega }}</span></th>
                    <td *ngFor="let c of campos" class="is-num">
                      <ng-container *ngIf="editandoMargenes; else valorTexto">
                        <span class="mv-input-caja">
                          <!-- step="any": acepta hasta 4 decimales sin que el navegador lo marque inválido -->
                          <input type="number" class="mv-input" min="0" [max]="limiteMargen" step="any"
                            [class.is-error]="!!erroresRuta(r.ruta)[c] || !!erroresRuta(r.ruta).rango"
                            [ngModel]="valorBorrador(r.ruta, c)" (ngModelChange)="cambiarMargen(r.ruta, c, $event)"
                            [attr.aria-label]="(c === 'minimo' ? 'Margen mínimo ' : 'Margen máximo ') + r.etiqueta + ', en %'"
                            [attr.aria-invalid]="!!erroresRuta(r.ruta)[c] || !!erroresRuta(r.ruta).rango"
                            [attr.aria-describedby]="idsErrorCampo(r.ruta, c)" />
                          <span class="mv-sufijo" aria-hidden="true">%</span>
                        </span>
                        <p *ngIf="erroresRuta(r.ruta)[c] as e" class="mv-error-campo" [id]="'mv-error-' + r.ruta + '-' + c">{{ e }}</p>
                      </ng-container>
                      <ng-template #valorTexto>
                        <span class="mv-valor">{{ formatoMargen(valorGuardado(r.ruta, c)) }}</span>
                      </ng-template>
                    </td>
                  </tr>
                  <tr *ngIf="editandoMargenes && erroresRuta(r.ruta).rango as e" class="mv-fila-error">
                    <td colspan="3" role="alert" [id]="'mv-error-' + r.ruta + '-rango'">{{ r.etiqueta }}: {{ e }}</td>
                  </tr>
                </ng-container>
              </tbody>
            </table>
          </div>

          <p class="mv-nota">
            El margen de cada franja es automático: la de montos más chicos lleva el máximo, la de montos más
            grandes el mínimo y las del medio se reparten en línea recta. Cada margen va de 0 a
            {{ formatoMargen(limiteMargen) }}, con hasta 4 decimales.
          </p>
          <p *ngIf="!margenesVes.completos && !editandoMargenes" class="mv-aviso mv-aviso--ambar">
            Faltan márgenes de alguna ruta: para guardar hay que completar los cuatro.
          </p>

          <!-- Lo que rige con lo guardado, sin editar -->
          <details *ngIf="pasoMargenes === 'viendo'" class="mv-detalle">
            <summary>
              Reparto por franja con los márgenes guardados{{ motorMargenesActivo ? '' : ' (no rige: el motor es Legado)' }}
            </summary>
            <ng-container *ngFor="let r of rutas; trackBy: trackRuta">
              <ng-container *ngTemplateOutlet="tablaReparto; context: { $implicit: r, filas: repartoActual(r.par), comparar: false }"></ng-container>
            </ng-container>
          </details>

          <div class="mv-acciones">
            <ng-container *ngIf="pasoMargenes === 'viendo'">
              <span *ngIf="margenesSoloLectura" class="mv-motivo mv-motivo--candado">
                <mat-icon aria-hidden="true">lock</mat-icon>{{ textoSoloLectura }}
              </span>
              <button *ngIf="puedeEditarMargenes" type="button" class="mv-btn mv-btn--primario" (click)="editarMargenes()"
                [disabled]="reaplicando">
                <mat-icon aria-hidden="true">edit</mat-icon>
                Cambiar márgenes o motor
              </button>
            </ng-container>
            <ng-container *ngIf="editandoMargenes">
              <span *ngIf="!puedeRevisarMargenes" class="mv-motivo" id="mv-motivo-revisar">{{ motivoNoRevisar }}</span>
              <button type="button" class="mv-btn mv-btn--secundario" (click)="descartarMargenes()">Descartar</button>
              <!-- Antes de la confirmación se relee lo guardado (otro operador pudo cambiarlo) -->
              <button type="button" class="mv-btn mv-btn--primario" (click)="revisarMargenes()"
                [disabled]="!puedeRevisarMargenes || revisandoMargenes"
                [attr.aria-busy]="revisandoMargenes"
                [attr.aria-describedby]="puedeRevisarMargenes ? null : 'mv-motivo-revisar'">
                <mat-spinner *ngIf="revisandoMargenes" diameter="16" class="mv-spinner-blanco"></mat-spinner>
                {{ revisandoMargenes ? 'Revisando…' : 'Revisar cambios' }}
              </button>
            </ng-container>
          </div>
        </ng-container>

        <!-- ───── Confirmando / guardando: antes → después y el reparto que queda ───── -->
        <div *ngIf="enConfirmacion && resumenCambiosMargenes as rc" class="mv-confirmacion"
          role="group" aria-labelledby="mv-confirmar-titulo">
          <!-- tabindex=-1: el foco llega acá al entrar a la confirmación -->
          <h3 id="mv-confirmar-titulo" class="mv-subtitulo" tabindex="-1">Revisa los cambios antes de guardar</h3>

          <p class="mv-cambio-motor" [class.is-cambia]="rc.motor.cambia">
            Motor:
            <ng-container *ngIf="rc.motor.cambia; else motorIgual">
              <span class="mv-antes">{{ rc.motor.antes }}</span> → <b>{{ rc.motor.despues }}</b>
            </ng-container>
            <ng-template #motorIgual>
              <b>{{ rc.motor.despues }}</b> <span class="mv-sin-cambio">(sin cambio)</span>
            </ng-template>
          </p>

          <div class="mv-tabla-caja">
            <table class="mv-tabla">
              <thead>
                <tr>
                  <th scope="col">Ruta</th>
                  <th scope="col" class="is-num">Margen mínimo</th>
                  <th scope="col" class="is-num">Margen máximo</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let f of rc.rutas; trackBy: trackFilaCambio">
                  <th scope="row">{{ f.etiqueta }}</th>
                  <td *ngFor="let c of campos" class="is-num" [class.is-cambia]="f[c].cambia">
                    <ng-container *ngIf="f[c].cambia; else celdaIgual">
                      <span class="mv-antes">{{ f[c].antes }}</span> → <b>{{ f[c].despues }}</b>
                      <!-- Con LEGADO, lo de antes está guardado pero no se cobra -->
                      <span *ngIf="antesNoRige" class="mv-antes-nota">antes: {{ textoAntesNoRige }}</span>
                    </ng-container>
                    <ng-template #celdaIgual>
                      {{ f[c].despues }} <span class="mv-sin-cambio">(igual)</span>
                    </ng-template>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <p *ngIf="cambiaMotor && motorFinal === 'MARGENES'" class="mv-aviso mv-aviso--ambar">
            Al pasar a Márgenes, las tasas CLP ↔ VES salen del spot cruzado con estos márgenes. La comisión CLP - VES,
            el descuento fiat y la comisión VES - CLP dejan de afectarlas.
          </p>
          <p *ngIf="cambiaMotor && motorFinal === 'LEGADO'" class="mv-aviso mv-aviso--ambar">
            Al volver a Legado, las tasas CLP ↔ VES vuelven a salir de la comisión y los descuentos. Los márgenes
            quedan guardados.
          </p>
          <p *ngIf="!cambiaMotor && motorFinal === 'LEGADO'" class="mv-nota">
            Con el motor Legado los márgenes quedan guardados, pero no cambian las tasas de hoy.
          </p>

          <h4 class="mv-subtitulo mv-subtitulo--chico">Reparto por franja con los márgenes nuevos</h4>
          <p class="mv-nota">
            Con el spot cruzado leído{{ horaLectura ? ' a las ' + horaLectura : '' }}. Es una vista previa: al guardar,
            las tasas las calcula el servidor con el spot de ese momento.
          </p>
          <ng-container *ngFor="let r of rutas; trackBy: trackRuta">
            <ng-container *ngTemplateOutlet="tablaReparto; context: { $implicit: r, filas: repartoNuevo(r.par), comparar: true }"></ng-container>
          </ng-container>

          <label for="mv-motivo" class="mv-etiqueta">Motivo <span class="mv-opcional">(opcional)</span></label>
          <textarea id="mv-motivo" rows="2" class="mv-input mv-input--area" [(ngModel)]="motivoMargenes"
            [maxlength]="motivoMargenesMax" [disabled]="guardandoMargenes"
            placeholder="Por ejemplo: bajo el margen mínimo de VES → CLP"></textarea>

          <div class="mv-acciones">
            <button type="button" class="mv-btn mv-btn--secundario" (click)="volverAEditarMargenes()" [disabled]="guardandoMargenes">
              Volver a editar
            </button>
            <button type="button" class="mv-btn mv-btn--primario" (click)="confirmarMargenes()" [disabled]="!puedeConfirmarMargenes">
              <mat-spinner *ngIf="guardandoMargenes" diameter="16" class="mv-spinner-blanco"></mat-spinner>
              {{ guardandoMargenes ? 'Guardando…' : 'Confirmar y guardar' }}
            </button>
          </div>
        </div>
      </ng-container>

      <!-- «Reintentar aplicar» en vuelo -->
      <p *ngIf="reaplicando" class="mv-cargando" role="status">
        <mat-spinner diameter="16"></mat-spinner>
        <span>Reintentando aplicar las tasas…</span>
      </p>

      <!-- Resultado del último guardado (o su error). tabindex=-1: el foco llega acá al terminar. -->
      <div *ngIf="resultadoMargenes as res" id="mv-resultado" tabindex="-1" class="mv-aviso mv-resultado"
        [class.mv-aviso--verde]="res.tipo === 'exito'" [class.mv-aviso--ambar]="res.tipo === 'aviso'"
        [class.mv-aviso--rojo]="res.tipo === 'error'"
        [attr.role]="res.tipo === 'exito' ? 'status' : 'alert'">
        <mat-icon aria-hidden="true">{{ res.tipo === 'exito' ? 'check_circle' : (res.tipo === 'aviso' ? 'warning' : 'error') }}</mat-icon>
        <div class="mv-resultado-cuerpo">
          <ul class="mv-lista">
            <li *ngFor="let t of res.textos">{{ t }}</li>
          </ul>
          <!-- Advertencias del back (p. ej., al volver a LEGADO con franjas que rompen sus reglas) -->
          <ul *ngIf="res.advertencias?.length" class="mv-lista mv-lista--advertencias" aria-label="Advertencias">
            <li *ngFor="let a of res.advertencias">{{ a }}</li>
          </ul>
          <button *ngIf="puedeReintentarAplicar" type="button" class="mv-btn mv-btn--secundario mv-reintentar"
            (click)="reintentarAplicar()">
            <mat-icon aria-hidden="true">refresh</mat-icon>
            Reintentar aplicar
          </button>
        </div>
      </div>
    </section>

    <!-- Reparto por franja de una ruta (guardado o con los márgenes nuevos) -->
    <ng-template #tablaReparto let-r let-filas="filas" let-comparar="comparar">
      <div class="mv-reparto">
        <p class="mv-reparto-titulo">{{ r.etiqueta }}</p>
        <p *ngIf="!filas.length" class="mv-nota">Sin franjas para repartir.</p>
        <div *ngIf="filas.length" class="mv-tabla-caja">
          <table class="mv-tabla mv-tabla--reparto">
            <thead>
              <tr>
                <th scope="col">Franja</th>
                <th scope="col">Desde – Hasta ({{ r.par === 'VES-CLP' ? 'CLP equiv.' : 'CLP' }})</th>
                <th scope="col" class="is-num">
                  Margen
                  <!-- Con LEGADO, el margen de antes está guardado pero no se cobra -->
                  <span *ngIf="comparar && antesNoRige" class="mv-th-nota">antes: {{ textoAntesNoRige }}</span>
                </th>
                <th scope="col" class="is-num">Tasa</th>
              </tr>
            </thead>
            <tbody>
              <ng-container *ngFor="let f of filas; trackBy: trackFila">
                <tr [class.is-tope]="f.pasaTope">
                  <td><span class="mv-letra">{{ f.letra }}</span></td>
                  <td class="is-nowrap">{{ rangoClp(f.desde, f.hasta) }}</td>
                  <td class="is-num is-nowrap">
                    <span *ngIf="comparar && f.margenAntes != null && formatoMargen(f.margenAntes) !== formatoMargen(f.margen)" class="mv-antes">
                      {{ formatoMargen(f.margenAntes) }} →
                    </span>
                    <b [class.mv-rojo]="f.pasaTope">{{ formatoMargen(f.margen) }}</b>
                  </td>
                  <td class="is-num">
                    <span class="mv-tasa">{{ textoTasaCliente(f.tasaClient) }}</span>
                    <span class="mv-sub">{{ textoTasaRuta(r.par, f.tasaRuta) }}</span>
                  </td>
                </tr>
                <!-- VES → CLP: el margen pasa el 5 % sobre el mid (aviso, no bloquea) -->
                <tr *ngIf="f.pasaTope" class="mv-fila-tope">
                  <td colspan="4">
                    <mat-icon aria-hidden="true">warning</mat-icon>
                    <span class="mv-fila-tope-texto">Franja {{ f.letra }}: {{ textoPasaTope }}</span>
                  </td>
                </tr>
              </ng-container>
            </tbody>
          </table>
        </div>
      </div>
    </ng-template>
  </div>

  <!-- Pie fijo, fuera del scroll (03/11/2026). «Guardar parámetros» es de la
       pestaña de parámetros; los márgenes tienen sus propios botones. -->
  <div class="eom-pie">
    <p *ngIf="margenesPendientes && pestana === 'parametros'" class="eom-pendiente" role="status">
      Guarda o descarta los cambios de márgenes antes de guardar los parámetros.
      <button type="button" class="eom-enlace" (click)="elegirPestana('margenes', true)">Ir a Márgenes</button>
    </p>
    <div class="flex flex-col sm:flex-row gap-2 justify-center eom-botones">
      <button type="button" (click)="onCancel()"
        [disabled]="guardandoMargenes"
        [style.opacity]="guardandoMargenes ? '0.5' : '1'"
        [style.cursor]="guardandoMargenes ? 'not-allowed' : 'pointer'"
        class="w-full sm:w-auto"
        style="display: inline-flex; align-items: center; justify-content: center; gap: 6px; padding: 8px 24px; background: white; color: #374151; border: 1px solid #d1d5db; border-radius: 10px; font-weight: 600; font-size: 0.85rem; cursor: pointer; transition: all 0.2s ease;"
        onmouseover="this.style.background='#f3f4f6'" onmouseout="this.style.background='white'">
        {{ pestana === 'parametros' ? 'Cancelar' : 'Cerrar' }}
      </button>
      <button *ngIf="pestana === 'parametros'" type="button" (click)="onSave()"
        [disabled]="form.invalid || margenesPendientes || guardandoMargenes"
        [style.opacity]="(form.invalid || margenesPendientes || guardandoMargenes) ? '0.5' : '1'"
        [style.cursor]="(form.invalid || margenesPendientes || guardandoMargenes) ? 'not-allowed' : 'pointer'"
        class="w-full sm:w-auto"
        style="display: inline-flex; align-items: center; justify-content: center; gap: 8px; padding: 10px 36px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.9rem; cursor: pointer; transition: background 0.2s ease;"
        onmouseover="this.style.background='#059669'" onmouseout="this.style.background='#1C593D'">
        <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: white;">save</mat-icon>
        Guardar parámetros
      </button>
    </div>
  </div>
</div>
